export default function getTaskStatusById(taskId = '') {
  return (state: any) => {
    return state.getIn(['apiTask', 'data', 'byId', taskId, 'status'], '');
  };
}
